import { render, staticRenderFns } from "./OnboardingTemplate.vue?vue&type=template&id=647a3219"
import script from "./OnboardingTemplate.vue?vue&type=script&lang=js"
export * from "./OnboardingTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports